// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3Hvl_","inner":"Footer_inner__3uaEl"};